module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/logo_jsco-e56badd34fc2d19ee11447c10995a038.svg";